<template>
      <div class="carousel-wrapper">
        <div class="carousel-wrapper-inner">
            <img class="carousel--left-arrow" @click="goToSlide(currentSlide - 1)" :src="arrowLeft" alt="left arrow">
                <div class="carousel" v-on:scroll="setCurrentSlide">
                    <div v-for="(image, index) in images" :key="index">
                        <img class="carousel-image" :src="image.original || image.image_original" :alt="altText">
                    </div>
                </div>
            <img class="carousel--right-arrow" @click="goToSlide(currentSlide + 1)" :src="arrowRight" alt="right arrow">
            <div class="carousel-pips">
                <i v-for="(image, index) in images" :key="index" @click="goToSlide(index)" class="carousel-pips__pip" :class="{ active: index === currentSlide }"></i>
            </div>
        </div>
      </div>
</template>

<script>
import leftArrow from '@/assets/images/decoration/arrow-circle-left.png';
import rightArrow from '@/assets/images/decoration/arrow-circle-right.png';

export default {
    name: 'ImageCarousel',
    data() {
        return {
            currentSlide: 0,
            carousel: '',
            arrowLeft: leftArrow,
            arrowRight: rightArrow,
        };
    },
    props: {
        images: {
            required: true,
            type: Array,
        },
        altText: {
            required: false,
            type: String,
            default: 'Product image',
        },
    },
    mounted() {
        this.carousel = this.$el.querySelector('.carousel');
    },
    methods: {
        setCurrentSlide() {
            this.currentSlide = this.carousel.scrollLeft / this.carousel.offsetWidth;
        },
        goToSlide(slideIndex) {
            const width = this.carousel.offsetWidth;
            this.carousel.scrollTo(width * slideIndex, 0);
        },
    },
};
</script>

<style scoped>
.carousel-wrapper-inner {
    position: relative;
}
.carousel--left-arrow, .carousel--right-arrow {
    width: 50px;
    height: auto;
    position: absolute;
    top: 40%;
    transition: .5s;
}

.carousel--left-arrow:hover, .carousel--right-arrow:hover {
    width: 60px;
    height: auto;
}

.carousel--right-arrow {
    right: 0;
}
</style>
